import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { PaymentSection } from 'src/app/shared/models/data/documentTemplate';
import { NodeSpec } from 'prosemirror-model';
import { createDocumentEditor, DOCUMENT_TEMPLATE_TOOLBAR } from 'src/app/shared/ngx-editor/document-template-editor';

@Component({
  selector: 'app-payment-section',
  templateUrl: './payment-section.component.html',
  styleUrls: ['./payment-section.component.scss']
})
export class PaymentSectionComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() reset!: () => void;
  @Input() payment: PaymentSection = {
    section: {
      value: ''
    }
  };
  @Output() paymentChange = new EventEmitter<PaymentSection>();

  selectDropdownNode: NodeSpec = {
    group: 'inline',
    inline: true,
    atom: true, // Keep it atomic but ensure it's fully interactive
    attrs: {
      id: { default: '' },
      options: { default: [] },
      value: { default: '' }
    },
    toDOM: (node) => {
      // Generate the select dropdown and allow interaction
      const select = document.createElement('select');

      // Assign the id to the select element
      if (node.attrs['id']) {
        select.id = node.attrs['id'];
      } else {
        select.id = `select_payment_terms`;
      }

      node.attrs['options'].forEach((option: { value: string; label: string }) => {
        const optionElement = document.createElement('option');
        optionElement.value = option.value;
        optionElement.textContent = option.label;

        // Set the selected attribute based on the value in the node's attrs
        if (node.attrs['value'] === option.value) {
          optionElement.selected = true;
        }

        select.appendChild(optionElement);
      });

      // Ensure select is interactive by not using atom-like behavior for interaction
      select.addEventListener('mousedown', (event) => {
        event.stopPropagation(); // Prevent ProseMirror from blocking the interaction
      });

      select.addEventListener('change', (event) => {
        const target = event.target as HTMLSelectElement;
        const selectedValue = target.value;

        if (select.id) {
          if (!this.payment.selectedValues)
            this.payment.selectedValues = {};
          this.payment.selectedValues![select.id] = selectedValue;
          this.paymentChange.emit(this.payment);
        }
      });

      return select;
    },
    parseDOM: [{
      tag: 'select',
      getAttrs: (dom) => {
        const options = Array.from(dom.querySelectorAll('option')).map((option: HTMLOptionElement) => ({
          value: option.value,
          label: option.textContent || option.value
        }));
        const value = (dom as HTMLSelectElement).value;  // Capture the selected value
        const id = (dom as HTMLSelectElement).id;  // Capture the id if present
        return { options, value, id };
      }
    }]
  };

  editor: Editor = createDocumentEditor({ nodes: { select_dropdown: this.selectDropdownNode } });
  toolbar: Toolbar = DOCUMENT_TEMPLATE_TOOLBAR;

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['payment'] && !changes['payment'].isFirstChange()) {
      const currentSection = changes['payment'].currentValue as PaymentSection;

      if (currentSection) {
        this.applySelectedValues(); // Reapply selected values in case the section changes
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.applySelectedValues();
    }, 0);
  }


  onEditorChange(newValue: string) {
    this.payment.section.value = newValue;
    this.payment.section.isModified = true;
    this.paymentChange.emit(this.payment);
  }

  applySelectedValues(): void {
    const editorContainer = document.getElementById(`payment-editor-container`);

    if (!editorContainer) {
      return;
    }

    const selects = editorContainer.querySelectorAll('select');
    selects.forEach(select => {
      const selectId = select.id;
      const selectedValue = this.payment.selectedValues?.[selectId];
      // If a selected value exists for this select, set it
      if (selectedValue) {
        select.value = selectedValue;
      } else {
        // set the first option as default if no value is found
        select.selectedIndex = 0;
      }
    });
  }

}
